import { render, staticRenderFns } from "./WorksImageContainer.vue?vue&type=template&id=35af2c61&scoped=true&"
import script from "./WorksImageContainer.vue?vue&type=script&lang=js&"
export * from "./WorksImageContainer.vue?vue&type=script&lang=js&"
import style0 from "./WorksImageContainer.vue?vue&type=style&index=0&id=35af2c61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35af2c61",
  null
  
)

export default component.exports